import { useSession } from '@ghq-abi/auth-client-lib/client';
import { Flex } from '@ghq-abi/design-system';

import { useNav } from '~/app/contexts/NavContext';
import { EnvironmentBanner } from '~/shared/components';
import { getEnv } from '~/shared/utils/environments';

import { HeaderActions } from '../HeaderActions';
import { LanguageDropdownHeader } from '../LanguageDropdown';
import { ModulesDropdown } from '../ModulesDropdown';
import { UserDropdown } from '../UserDropdown';

import { StyledHeader } from './styles';

export function Header() {
    const session = useSession();
    const user = session.data?.user.proxiedAs ?? session.data?.user;

    const { isAppMenuOpen } = useNav();

    const env = getEnv();

    return (
        <StyledHeader isMenuOpen={isAppMenuOpen}>
            <HeaderActions />
            {env !== 'production' && <EnvironmentBanner environment={env} />}
            <Flex gap="md" align="center">
                <LanguageDropdownHeader currentLanguage={user?.language} />
                <ModulesDropdown />
                <UserDropdown />
            </Flex>
        </StyledHeader>
    );
}
